// Shared video-URL helpers.
// Normalize any pasted YouTube/Vimeo URL into an iframe-embeddable form so
// downstream players (Test Library, Program Builder, Athlete workout view,
// coach client detail) all render the same regardless of what a user pasted.

// Accepts: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/shorts/ID,
// youtube.com/embed/ID, vimeo.com/ID (+ trailing tracking params).
export const normalizeVideoUrl = (u = "") => {
  if (!u || typeof u !== "string") return u;
  const s = u.trim();
  if (!s) return s;
  const ytEmbed = /(?:youtube\.com\/embed\/)([\w-]{6,})/i.exec(s);
  if (ytEmbed) return `https://www.youtube.com/embed/${ytEmbed[1]}`;
  const ytWatch = /(?:youtube\.com\/watch\?(?:.*&)?v=)([\w-]{6,})/i.exec(s);
  if (ytWatch) return `https://www.youtube.com/embed/${ytWatch[1]}`;
  const ytShort = /(?:youtu\.be\/)([\w-]{6,})/i.exec(s);
  if (ytShort) return `https://www.youtube.com/embed/${ytShort[1]}`;
  const ytShorts = /(?:youtube\.com\/shorts\/)([\w-]{6,})/i.exec(s);
  if (ytShorts) return `https://www.youtube.com/embed/${ytShorts[1]}`;
  const vimeo = /(?:vimeo\.com\/(?:video\/)?)(\d{6,})/i.exec(s);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  return s;
};

export const isEmbeddableVideoUrl = (u = "") =>
  /youtube\.com\/embed|player\.vimeo\.com\/video/.test(u);

export const isVideoHostUrl = (u = "") =>
  /youtube\.com|youtu\.be|vimeo\.com|player\.vimeo/.test(u);
